// Formato nominativo: "Cognome Nome" per persone fisiche, "Ragione Sociale" per aziende.
// Il flag soggetto_iva == "E" indica soggetto con partita IVA (azienda), "NO" persona fisica.

export const isAzienda = (r = {}) => {
  if (r.soggetto_iva === "E" || r.soggetto_iva === "SI") return true;
  if (r.soggetto_iva === "NO") return false;
  if (r.partita_iva || r.denominazione) return true;
  if (r.ragione_sociale && !r.cognome && !r.nome) return true;
  return false;
};

export const formatNominativo = (r = {}) => {
  if (isAzienda(r)) {
    return r.ragione_sociale || r.denominazione || [r.cognome, r.nome].filter(Boolean).join(" ").trim();
  }
  return [r.cognome, r.nome].filter(Boolean).join(" ").trim() || r.ragione_sociale || r.denominazione || "";
};
